import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .searches-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .search-chip {
    display: flex;
    align-items: stretch;
    border-radius: 6px;
    overflow: hidden;
    max-width: 100%;
  }

  .search-chip-name {
    background-color: #17a2b8;
    color: #fff;
    border: none;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    white-space: normal;
    word-break: break-word;
    text-align: left;
    cursor: pointer;

    &:hover {
      background: #007487;
    }
  }

  .search-chip.active .search-chip-name {
    background: #007487;
  }

  .search-chip-name.btn-ia,
  .search-chip.active .search-chip-name.btn-ia {
    background: linear-gradient(90deg, #007bff, #009f79);
  }

  .search-chip-action {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #007487;
    border: none;
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    padding: 6px 8px;
    cursor: pointer;

    &:hover {
      background: #005f6b;
    }

    .material-icons {
      font-size: 18px;
    }
  }

  .search-chip-action.btn-ia {
    background: linear-gradient(90deg, #007bff, #009f79);

    &:hover {
      background: linear-gradient(90deg, #0060cc, #007a5e);
    }
  }

  btn-teste {
    background: #009f79;
  }
`;
